import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <h4 class="wc-heading text-primary">Cabeçalho</h4>
`;

export class WCHeading extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcHeading = clone.content.querySelector('.wc-heading');
    wcHeading.innerHTML = '';
    contentNodes.forEach(node => {
      wcHeading.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcHeading);
  }

}